const home = [
  {
    component: () => import('@/app/milestone/pages/home/MilestoneHome.vue'),
    name: 'Home',
    path: '/',
    meta: {
      title: 'Accueil'
    }
  },
];

const site = [
  {
    component: () => import('@/app/milestone/pages/Site_Milestone.vue'),
    name: 'Site',
    path: '/site/:sit_id(\\d+)',
    meta: {
      title: 'Site'
    }
  },
]

const router = [
  ...home,
  ...site,
];

export default router;
